<template>
	<div class="left display-flex flex-column">
		<div class="top width-100" :class="{ full: showMore || !isIdeaSavedToAccount }">
			<div class="content">
				<IdeaFormattedTitle :idea="idea" />
				<IdeaFormattedDescription :idea="idea" class="mt-4" ref="content" />
				<div v-if="videoUrl" class="video-container mt-5">
					<iframe
						frameborder="0"
						allowfullscreen
						:src="videoUrl"
						mozallowfullscreen
						webkitallowfullscreen
						class="width-100 height-100 rounded"
					/>
				</div>
			</div>
			<div class="mt-1" v-if="isIdeaSavedToAccount && isOverflow">
				<h3 @click="showMore = !showMore" class="medium link mb-2">Show {{ showMore ? 'less' : 'more' }}</h3>
			</div>
			<v-divider class="mt-2" />
		</div>
		<IdeaComments v-if="isIdeaSavedToAccount" class="bottom width-100 flex-1" :ideaId="idea.id" ref="comments" />
	</div>
</template>
<script>
import { sanitizeHtml } from '@/utils/helpers';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service';
import { userFavoritePlyServicesIds } from '@/store/modules/auth/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import IdeaComments from './IdeaComments.vue';
import IdeaFormattedTitle from '@/components/dialogs/IdeaDialog/IdeaFormattedTitle.vue';
import IdeaFormattedDescription from '@/components/dialogs/IdeaDialog/IdeaFormattedDescription.vue';
import detectElementOverflow from 'detect-element-overflow';
export default {
	name: 'IdeaDialogLeftSide',
	components: {
		IdeaComments,
		IdeaFormattedTitle,
		IdeaFormattedDescription,
	},
	props: { idea: { type: Object } },
	computed: {
		...mapGettersShorthand({ userFavoritePlyServicesIds }),
		formattedTitle() {
			return InspirationCenterService.formatContentWithServiceDetails(this.idea.title, this.idea.params, this.userFavoritePlyServicesIds);
		},
		formattedDescription() {
			return InspirationCenterService.formatContentWithServiceDetails(
				this.idea.description,
				this.idea.params,
				this.userFavoritePlyServicesIds
			);
		},
		videoUrl() {
			return this.idea.video_url;
		},
		isIdeaSavedToAccount() {
			return InspirationCenterService.isIdeaSavedToAccount(this.idea);
		},
	},
	methods: {
		getCleanHtml(dirtyContent) {
			return sanitizeHtml(String(dirtyContent));
		},
		focusPostCommentInput() {
			this.$refs.comments.focusPostCommentInput();
		},
	},
	data() {
		return {
			showMore: false,
			isOverflow: false,
		};
	},
	mounted() {
		this.$nextTick(() => {
			const { collidedBottom } = detectElementOverflow(this.$refs.content.$el, this.$refs.content.$el.parentNode);
			this.isOverflow = collidedBottom;
		});
	},
};
</script>

<style scoped lang="scss">
.left {
	padding: 40px 28px 20px 28px;
	overflow: auto;
	max-height: 100%;
}
.title-cont {
	font-size: 16px;
	color: #292829;
	font-weight: 600;
}
.top {
	max-height: 235px;
	.content {
		overflow: auto;
		max-height: 190px;
	}
	&.full {
		max-height: none;
		.content {
			max-height: none;
		}
	}
}
.bottom {
	min-height: 230px;
}
.medium {
	font-weight: medium;
}
.video-container {
	width: 470px;
	height: 265px;
	border-radius: 8px;
}
.rounded {
	border-radius: 8px;
}
</style>
